import { render, staticRenderFns } from "./AdvertisementsDetails.vue?vue&type=template&id=165c0b4f&scoped=true&"
import script from "./AdvertisementsDetails.vue?vue&type=script&lang=js&"
export * from "./AdvertisementsDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementsDetails.vue?vue&type=style&index=0&id=165c0b4f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c0b4f",
  null
  
)

export default component.exports